import { useNavigate } from 'react-router';

import { useDispatch, useSelector } from 'react-redux';
import { selectAnnouncements } from '../slices/inboxSlice';
import {
  useLazyGetAllAnnouncementsQuery,
  useMarkAnnouncementAsReadByMatchIdMutation,
} from '../slices/inboxApiSlice';
import { selectUser } from '../slices/auth';
import { OutsideClick } from './outside-click';
import { InboxAnnouncementTypes, InboxAnnouncementTypesNames } from '../utils/constants';
import { dateAndTimeFormatter } from '../utils/dateFormatter';

const AnnouncementPopUp = () => {
  const user = useSelector(selectUser);
  const announcements = useSelector(selectAnnouncements);

  const announcement = announcements?.find(
    (a: any) =>
      !a.Recipients.some((ar: any) => ar.userId === user.id && ar.lastReadDate > a.send_time),
  );
  const [getAnnouncements] = useLazyGetAllAnnouncementsQuery();
  const [markAnnouncemensAsRead] = useMarkAnnouncementAsReadByMatchIdMutation();

  function onClick() {
    markAnnouncemensAsRead({ id: +announcement?.id! });
    getAnnouncements({});
  }

  function formatMessageTimestamps(message?: string): string {
    if (!message) return '';

    return message.replace(
      /(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z)/g,
      (match, isoString) => {
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return match;
        return dateAndTimeFormatter(isoString, 'MMMM D, YYYY h:mm A z');
      },
    );
  }

  return (
    <>
      <OutsideClick />
      <div className='modalBackground fixed top-0 left-0 right-0 bottom-0 m-auto z-10'>
        <div className='modalContainer'>
          <p className='text-left text-gray-400'>ANNOUNCEMENT</p>

          <p className='text-left text-fen-red text-2xl mb-7'>
            {announcement &&
              InboxAnnouncementTypesNames[
                +announcement.inbox_announcement_type as InboxAnnouncementTypes
              ]}
          </p>
          <div className='overflow-y-auto p-4 whitespace-pre-line'>
            {formatMessageTimestamps(announcement?.message)}
          </div>
          <div className='flex flex-col mt-auto justify-end'>
            <span className='text-grey-300 text-center'>
              By clicking below you are acknowledging that you will speak to the aforementioned team
              and confirm their participation in their next match.
            </span>
            <div className='flex  justify-end'>
              <button
                onClick={onClick}
                className='w-1/3 my-12 py-1 bg-red-700 shadow-lg text-white font-semibold rounded-lg ml-4'
              >
                Acknowledge
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AnnouncementPopUp;
